import { Search } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { StatusBadge } from "@/components/StatusBits";
import { fmtDT } from "@/lib/api";

const STATUSES = ["all", "new", "attempting", "callback_scheduled", "contacted", "resolved", "do_not_call", "opted_out", "wrong_number"];

export const QueueList = ({ contacts, selectedId, onSelect, q, setQ, status, setStatus, sessionIds }) => (
  <section className="lg:col-span-3 flex flex-col gap-3 bg-white border border-slate-200 rounded-lg p-3 min-h-0" data-testid="queue-panel">
    <div className="flex items-center justify-between">
      <h2 className="font-heading text-sm font-semibold text-slate-800">Contact queue</h2>
      <span className="text-xs text-slate-500" data-testid="queue-count">{contacts.length} contacts</span>
    </div>
    <div className="relative">
      <Search className="h-4 w-4 absolute left-2.5 top-2.5 text-slate-400" />
      <Input data-testid="queue-search-input" className="pl-8 h-9" placeholder="Search name, business, phone, tag" value={q} onChange={(e) => setQ(e.target.value)} />
    </div>
    <Select value={status || "all"} onValueChange={(v) => setStatus(v === "all" ? "" : v)}>
      <SelectTrigger data-testid="queue-status-filter" className="h-9 bg-white text-xs"><SelectValue /></SelectTrigger>
      <SelectContent className="bg-white">
        {STATUSES.map((s) => <SelectItem key={s} value={s}>{s === "all" ? "All statuses" : s.replace(/_/g, " ")}</SelectItem>)}
      </SelectContent>
    </Select>
    <div className="flex-1 overflow-y-auto scroll-thin -mx-1 min-h-[200px]">
      {contacts.map((c) => (
        <button key={c.id} onClick={() => onSelect(c.id)} data-testid={`queue-item-${c.id}`}
          className={`w-full text-left px-2.5 py-2 mx-1 rounded-md border-l-2 transition-colors duration-200 ${selectedId === c.id ? "bg-slate-100 border-zinc-900" : "border-transparent hover:bg-slate-50"}`}>
          <div className="flex items-center justify-between gap-2">
            <span className="text-sm font-medium text-slate-900 truncate">{c.name}</span>
            <StatusBadge value={c.status} />
          </div>
          <div className="flex items-center justify-between text-[11px] text-slate-500 mt-0.5">
            <span className="truncate">{c.business || c.phone}</span>
            {c.active_call_id ? <span className="text-emerald-700 font-medium">On call</span>
              : c.callback_at ? <span>CB {fmtDT(c.callback_at)}</span>
              : c.next_eligible_at ? <span>Next {fmtDT(c.next_eligible_at)}</span> : null}
          </div>
          {sessionIds?.has(c.id) && <span className="text-[10px] text-blue-700">In session queue</span>}
        </button>
      ))}
      {!contacts.length && <p className="text-xs text-slate-500 p-3" data-testid="queue-empty">No contacts. Add or import them on the Contacts page.</p>}
    </div>
  </section>
);
